var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /** @format */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { IconSelector } from "../../ReactReduxForms";
import { actions } from "./..";
import { FormValue } from "../../Forms";
import ToggleDisplay from "../../Layout/ToggleDisplay";
import { bindActionCreators } from 'redux';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";

export const IconFieldBase = ({ model, removeIcon }) => /*#__PURE__*/
_jsx(FormValue, { model: `${model}.icon` }, void 0,
(icon = {}) => /*#__PURE__*/
_jsx("div", { className: "icon-selector" }, void 0, /*#__PURE__*/
_jsx(ToggleDisplay, {
  showLabel: /*#__PURE__*/
  _jsx("span", {}, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "add icon"), /*#__PURE__*/
  _jsx(Icon, { icon: "eye" })
  ),

  hideLabel: /*#__PURE__*/
  _jsx("span", {}, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "remove icon"), /*#__PURE__*/
  _jsx(Icon, { icon: "eye-slash" })
  ),

  onHide: () => removeIcon(`${model}.icon`),
  open: !!icon._id }, void 0, /*#__PURE__*/

_jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
_jsx("li", {}, void 0, /*#__PURE__*/
_jsx("label", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Icon"), " / ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Flag")
)
), /*#__PURE__*/
_jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
_jsx(IconSelector, { model: ".icon" })
)
)
)
)

);







function mapDispatchToProps(dispatch) {
  return bindActionCreators({ removeIcon: actions.removeIcon }, dispatch);
}

export const IconField = connect(null, mapDispatchToProps)(IconFieldBase);